import { TFunction } from "i18next";
import { SecondaryColor, SemanticColor } from "node-library/dist/colors";
import { UserStatus, UserType } from "node-library/dist/constants";
import { UserTableSortColumn } from "node-library/dist/paginations";

export function checkUserTypeMeetsRequirement(
	userType: UserType,
	userTypeRequired: UserType,
	openToAll?: boolean
): boolean {
	if (openToAll) {
		return (
			userType === UserType.SYSTEM_ADMIN ||
			userType === UserType.CLIENT ||
			userType === UserType.ENGINEER ||
			userType === UserType.SHIPPING ||
			userType === UserType.ENGINEER_ADMIN ||
			userType === UserType.ADMIN
		);
	}
	switch (userType) {
		case UserType.SYSTEM_ADMIN:
			return true;
		case UserType.ADMIN:
			return userTypeRequired !== UserType.SYSTEM_ADMIN;
		case UserType.ENGINEER_ADMIN:
			return (
				userTypeRequired !== UserType.SYSTEM_ADMIN &&
				userTypeRequired !== UserType.ADMIN &&
				userTypeRequired !== UserType.CLIENT
			);
		case UserType.ENGINEER:
			return (
				userTypeRequired === UserType.ENGINEER ||
				userTypeRequired === UserType.SHIPPING
			);
		case UserType.SHIPPING:
			return userTypeRequired === UserType.SHIPPING;
		case UserType.CLIENT:
			return userTypeRequired === UserType.CLIENT;
		default:
			return false;
	}
}

export function getUserStatusString(
	status: UserStatus,
	translation: TFunction<"translation", undefined>
): string {
	switch (status) {
		case UserStatus.VALIDATING_EMAIL:
			return translation("Validating");
		case UserStatus.REGISTERED:
			return translation("Registered");
	}
}

export function getUserSortString(
	sortColumn: UserTableSortColumn,
	translation: TFunction<"translation", undefined>
): string {
	switch (sortColumn) {
		case UserTableSortColumn.CLIENT_COMPANY_NAME:
			return translation("CompanyName");
		case UserTableSortColumn.INSERTED:
			return translation("RegistrationTime");

		case UserTableSortColumn.USER_NAME:
			return translation("Email");
		case UserTableSortColumn.ROLE:
			return translation("Role");
		case UserTableSortColumn.FIRST_NAME:
			return translation("FirstName");
		case UserTableSortColumn.LAST_NAME:
			return translation("LastName");
	}
}

export function getUserStatusColors(status: UserStatus): {
	backgroundColor: string;
	borderColor: string;
	textColor: string;
} {
	switch (status) {
		case UserStatus.VALIDATING_EMAIL:
			return {
				backgroundColor: SecondaryColor.SECONDARY_100,
				borderColor: SecondaryColor.SECONDARY_500,
				textColor: SecondaryColor.SECONDARY_600,
			};
		case UserStatus.REGISTERED:
			return {
				backgroundColor: SemanticColor.SUCCESS_100,
				borderColor: SemanticColor.SUCCESS,
				textColor: SemanticColor.SUCCESS_300,
			};
	}
}

export function getUserRoles(
	role: UserType,
	translation: TFunction<"translation", undefined>
): string {
	switch (role) {
		case UserType.SYSTEM_ADMIN:
			return translation("System Admin");
		case UserType.ADMIN:
			return translation("Admin");
		case UserType.ENGINEER_ADMIN:
			return translation("Engineer Admin");
		case UserType.ENGINEER:
			return translation("Engineer");
		case UserType.SHIPPING:
			return translation("Shipping");
		case UserType.CLIENT:
			return translation("Client");
	}
}
